import { render, staticRenderFns } from "./DemandedSkills.vue?vue&type=template&id=676803c6&scoped=true&"
import script from "./DemandedSkills.vue?vue&type=script&lang=js&"
export * from "./DemandedSkills.vue?vue&type=script&lang=js&"
import style0 from "./DemandedSkills.vue?vue&type=style&index=0&id=676803c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676803c6",
  null
  
)

export default component.exports